import { render, staticRenderFns } from "./ClientTokenTable.vue?vue&type=template&id=8f025c70&"
import script from "./ClientTokenTable.vue?vue&type=script&lang=js&"
export * from "./ClientTokenTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports